import ShopCommissionsControls from './ShopCommissionsControls';
import ShopCommissionsControlsContainer from './ShopCommissionsControls.container';

export default ShopCommissionsControlsContainer(ShopCommissionsControls);
